import React from 'react';
import SocialLinks from './SocialLinks';
import FooterNav from './FooterNav';
import '../../stylesheets/stylesLayout/footer.scss';

const Footer = ({ isExternalPage }) => {
    // por ejemplo /jobs se ve desde fastpayhotels.com y sólo se tienen que ver los links a redes sociales pero no los de contact us
    const muggle = isExternalPage ? 'flex-center' : 'flex-between';

    const isVisible = isExternalPage ? false : true;

    return (
        <footer className={`footer ${muggle}`}>
            {isVisible && <FooterNav />}
            <SocialLinks />
        </footer>
    );
};

export default Footer;
